// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"134":"d4128382e54a1a14","501":"d72417b80aaa29c3"}[chunkId] + ".js";
};